import React from "react";
import useTranslate from "hooks/use-translate-language";
import moment from "moment";
import "./schedule-chat.scss";
import { Spinner } from "components/ui";
import {
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  TextField,
  FormLabel
} from "@mui/material";

const ChooseSlot = ({
  isFetching,
  timeslots,
  description,
  setDescription,
  selectedTimeSlot,
  setSelectedTimeSlot
}) => {
  const translate = useTranslate();

  return (
    <div style={{ marginTop: "3%", marginBottom: "2%" }}>
      <div className="timeslots-container">
        <div className="schedules-list-container">
          <FormControl
            component="fieldset"
            style={{ width: "100%", marginLeft: "2%" }}
          >
            <FormLabel
              component="legend"
              className="topic-title"
              id="choose-timeslot"
            >
              {translate("chooseATimeSlot")}
            </FormLabel>
            {isFetching ? (
              <div className="spinner-container">
                <Spinner />
              </div>
            ) : (
              <>
                {timeslots != null ? (
                  <RadioGroup
                    aria-labelledby="choose-timeslot"
                    name="time-slot"
                    className="coach-timeslots-container"
                    value={selectedTimeSlot}
                    row
                    onChange={({ target }) => setSelectedTimeSlot(target.value)}
                  >
                    {timeslots.map(coach =>
                      coach.AvailabilitySlotsTimes.map(slot => {
                        const start_time = moment(slot.Start, "HH:mm").format(
                          "hh:mma"
                        );
                        const end_time = moment(slot.End, "HH:mm").format(
                          "hh:mma"
                        );
                        return (
                          <FormControlLabel
                            value={`${coach.CoachId}_${start_time}/${end_time}`}
                            control={
                              <Radio
                                color="secondary"
                                sx={{
                                  color: "#337abb",
                                  "&.Mui-checked": {
                                    color: "#337abb"
                                  }
                                }}
                              />
                            }
                            label={`${coach.CoachName} | ${start_time.slice(
                              0,
                              5
                            )} ${start_time.slice(5, 7).toUpperCase()}`}
                            key={`${coach.CoachId}_${start_time}-${end_time}`}
                          />
                        );
                      })
                    )}
                  </RadioGroup>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flex: 1,
                      justifyContent: "center",
                      alignItems: "center",
                      color: "red"
                    }}
                  >
                    {translate("noFoundTimeSlots")}
                  </div>
                )}
              </>
            )}
          </FormControl>
          <TextField
            className="description"
            label={translate("enterDescription")}
            value={description}
            onChange={value => setDescription(value.target.value)}
            margin="normal"
            color="secondary"
            multiline
            focused
            aria-multiline={true}
            aria-label={translate("enterDescription")}
          />
        </div>
      </div>
    </div>
  );
};

export default ChooseSlot;
